import { BaseField, withClassName } from '@epages/react-components'
import { Component, cloneElement } from 'react'
import PropTypes from 'prop-types'
import cc from 'classcat'

import ErrorMessage from './ErrorMessage'
import InfoGroup from './InfoGroup'

/*
 * Composition of `InfoGroup`, `label`, `ErrorMessage` and actual form component
 */
export class UnstyledFormGroup extends Component {
  static contextType = BaseField.contextType

  static propTypes = {
    ...BaseField.propTypes,
    children: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    required: PropTypes.bool,
    tagName: PropTypes.string,
    disabled: PropTypes.bool,
  }

  render() {
    const {
      name,
      tagName = 'div',
      title,
      label,
      labelAfterComponent,
      info,
      meta,
      children,
      required,
      labelClassName,
      disabled,
      ...other
    } = this.props
    const labelInfoGroup = (
      <InfoGroup key={label} info={info} meta={meta} disabled={disabled}>
        <span className={cc(['ep-form-row-label-text', labelClassName])}>
          {label}
          {required ? '*' : ''}
        </span>
      </InfoGroup>
    )

    const component = labelAfterComponent
      ? [cloneElement(children, { key: name, name, required }), labelInfoGroup]
      : [labelInfoGroup, cloneElement(children, { key: name, name, required })]
    const TagName = tagName

    return (
      <div {...other}>
        <TagName title={title} className="ep-form-row-label">
          {component}
        </TagName>
        <ErrorMessage name={name} />
      </div>
    )
  }
}

export default withClassName('ep-form-row')(UnstyledFormGroup)
